import { StudentPreInterviewsUIProvider } from "./StudentPreInterviewsUIContext";
import { StudentPreInterviewsCard } from "./StudentPreInterviewsCard";

export function StudentPreInterviewsPage({ history }) {
  const preInterviewsUIEvents = {
    openNewStudentPreInterviewPage: () => {
      history.push("/on-kayit-ve-gorusmeler/ekle");
    },
    openEditStudentPreInterviewPage: (id) => {
      history.push(`/on-kayit-ve-gorusmeler/duzenle/${id}`);
    },
    openFinalRegistrationPage: (id) => {
      history.push(`/ogrenciler/kesin-kayit/${id}`);
    },
  };
  
  return (
    <StudentPreInterviewsUIProvider preInterviewsUIEvents={preInterviewsUIEvents}>
      <StudentPreInterviewsCard />
    </StudentPreInterviewsUIProvider>
 );
}